import { Flex, Section } from '@farmersdog/corgi-x';

import { TextTypeRenderer } from '../../../components/TextTypeRenderer';

import { BuildYourPlanCard } from './BuildYourPlanCard';

import type { BreedDocument } from '../types';

export interface BuildYourPlanProps {
  document: BreedDocument;
  breed: string;
}

export function BuildYourPlan({ document, breed }: BuildYourPlanProps) {
  const ariaLabel = `Build a plan for your ${breed}`;

  return (
    <Section
      aria-label={ariaLabel}
      hSpacing={{ xs: 12, sm: 24, md: 48, xl: 0 }}
      vSpacing={96}
      widthConstraint="lg"
    >
      <Flex direction="column" gap={36}>
        <div>
          <TextTypeRenderer nodes={document.data.benefits_text_1} />
        </div>
        <BuildYourPlanCard breed={breed} />
        <div>
          <TextTypeRenderer nodes={document.data.benefits_text_2} />
        </div>
      </Flex>
    </Section>
  );
}
